<template>
  <div class="product-category product-category-container flex-hl-vc">
    <div class="product-category-item flex-hc-vc flex-v" :class="[currentProduct === item.key ? 'actived' : '', item.disabled ? 'disabled' : '']" v-for="(item, index) in productBaseFilter" :key="index" @click="handleSelectCategory(item)" >
      <img class="product-category-item-icon" :src="item.icon" alt="">
      <!-- <l8-icon class="l8-icon product-category-item-icon" :type="`icon-caterory-${item.className}`"></l8-icon> -->
      <span class="product-category-item-title">{{ item.title }}</span>
    </div>
  </div>
</template>
<script>

import { debounce } from 'lodash'

export default {
  props: {
    cart: {
      type: Object
    },
    productBase: Object,
    currentProduct: String
  },
  data () {
    return {}
  },
  computed: {
    productBaseFilter () {
      const _productBase = Object.entries(this.productBase)
      const _productBaseFilter = _productBase.filter(([key, item]) => item.followSwitchStatus)
      return Object.fromEntries(_productBaseFilter)
    }
  },
  methods: {
    handleSelectCategory: debounce(function (item) {
      this.$emit('select', item.key)
    }, 300)
  }
}
</script>
<style lang="less" scoped>
  .product-category{
    margin-bottom: 25px;
    &-item {
      flex: 1 0 auto;
      width: 110px;
      height: 110px;
      padding: 15px;
      margin-right: 30px;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0px 10px 147px 0px rgba(0, 0, 0, 0.03);
      cursor: pointer;
      transition: all 0.5s;
      &.disabled {
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.5;
        background-color: #ddd;
      }
      &:hover, &.actived:not(:only-child) {
        transform: scale(1.05, 1.05);
        border: 1px solid @primary-color;
      }
      &-icon {
        margin-bottom: 10px;
        height: 60px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>
